import { Run } from '@bringg/types';

import { useStores } from 'bringg-web/recipes';
import useRouteMonitoringStore from '../stores/helpers/use-route-monitoring-store';
import { DetailedRun } from '../stores/routes-monitoring-store';

export const useRouteTrailer = (route: DetailedRun | Run) => {
	const { vehiclesStore } = useStores();
	const {
		routesMonitoringStore: { tasksByRun }
	} = useRouteMonitoringStore();

	const tasksMap = tasksByRun.get(route?.id);

	if (!route || !tasksMap) {
		return { trailerId: null, trailerName: null };
	}

	const [firstTaskId] = tasksMap.keys();

	const taskInRun = tasksMap.get(firstTaskId);

	const trailerId = taskInRun && taskInRun.vehicle_id !== route.vehicle_id ? taskInRun.vehicle_id : null;
	const trailerName = trailerId ? vehiclesStore.get(trailerId)?.name || null : null;

	return { trailerId, trailerName };
};
